(() => {
  'use strict';
  const NOTICE_SELECTOR = '.tax-note, .product__tax';
  const DIGITAL_DELIVERY = 'Digital delivery — no shipping required.';
  function replacementFor(rawText) {
    const text = String(rawText || '').replace(/\s+/g, ' ').trim();
    if (!/shipping/i.test(text) || !/checkout/i.test(text)) return null;
    if (/duties\s+and\s+taxes\s+included/i.test(text)) return `Duties and taxes included. Discounts calculated at checkout. ${DIGITAL_DELIVERY}`;
    if (/taxes\s+included/i.test(text)) return `Taxes included. Discounts calculated at checkout. ${DIGITAL_DELIVERY}`;
    if (/duties\s+included/i.test(text)) return `Duties included. Taxes and discounts calculated at checkout. ${DIGITAL_DELIVERY}`;
    if (/tax/i.test(text)) return `Taxes and discounts calculated at checkout. ${DIGITAL_DELIVERY}`;
    return DIGITAL_DELIVERY;
  }
  function rewriteNotice(element) {
    if (!(element instanceof Element)) return;
    const replacement = replacementFor(element.textContent);
    if (!replacement) return;
    element.textContent = replacement;
    element.setAttribute('data-mmg-digital-delivery-authority-v1', 'true');
  }
  function scan(scope) {
    const root = scope instanceof Element ? scope : document;
    if (root instanceof Element && root.matches(NOTICE_SELECTOR)) rewriteNotice(root);
    root.querySelectorAll?.(NOTICE_SELECTOR).forEach(rewriteNotice);
  }
  const relevant=node=>node instanceof Element&&(node.matches(NOTICE_SELECTOR)||!!node.querySelector?.(NOTICE_SELECTOR));
  function boot() {
    scan(document);
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver((mutations) => {
      for (const mutation of mutations) for (const node of mutation.addedNodes) if (relevant(node)) scan(node);
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
})();
